// extracted by mini-css-extract-plugin
export default {"container":"styles_container__ttQkR","cards":"styles_cards__IZf11"};